import { memo } from "react";

import CameraAltIcon from "@material-ui/icons/CameraAlt";

import { WidgetComponentType } from "models/screenshot";

import { ToolbarButton } from "components/base";
import { useScreenshotDispatch } from "components/screenshot/hooks";
import { useChartState } from "components/shared/charts";

const ScreenshotToggle = ({
  widgetComponentType
}: {
  widgetComponentType: WidgetComponentType;
}) => {
  const screenshotDispatch = useScreenshotDispatch();
  const { screenshot, id } = useChartState();

  // update screenshot state when legend is toggled
  const toggle = () => (value) => {
    const next = { ...screenshot, visible: value };

    const widget = value
      ? {
          widgetId: id,
          widgetComponentType
        }
      : null;

    screenshotDispatch({
      payload: {
        settings: next.preset,
        widget
      }
    });
  };

  return (
    <ToolbarButton
      key="screenshot"
      active={screenshot.visible}
      icon={<CameraAltIcon fontSize="large" />}
      overflowLabel="Screenshot"
      tooltipText="Screenshot"
      onToggle={toggle()}
    />
  );
};

export default memo(ScreenshotToggle);
